import { combineReducers } from '@reduxjs/toolkit';

import { analyticsContractorSlice } from './analyticsContractorSlice';
import { analyticsRatingSlice } from './analyticsRatingSlice';
import { analyticsReportingOvpSlice } from './analyticsReportingOvpSlice';
import { analyticsTransferToSettlementSlice } from './analyticsTransferToSettlementSlice';

export const analytics = combineReducers({
  analyticsContractor: analyticsContractorSlice.reducer,
  analyticsRating: analyticsRatingSlice.reducer,
  analyticsReportingOvp: analyticsReportingOvpSlice.reducer,
  analyticsTransferToSettlement: analyticsTransferToSettlementSlice.reducer,
});
